/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { FilterOption, FilterOption$inboundSchema } from "./filteroption.js";

/**
 * Result of listing filter options
 */
export type ListFilterOptionsResult = {
  /**
   * List of filter options
   */
  options: Array<FilterOption>;
};

/** @internal */
export const ListFilterOptionsResult$inboundSchema: z.ZodMiniType<
  ListFilterOptionsResult,
  unknown
> = z.object({
  options: z.array(FilterOption$inboundSchema),
});

export function listFilterOptionsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListFilterOptionsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListFilterOptionsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListFilterOptionsResult' from JSON`,
  );
}
